<template>
  <BContainer
    v-if="currentUser"
    class="mb-4"
  >
    <div class="d-flex flex-column flex-md-row justify-content-end mb-3 gap-3">
      <div class="order-md-2 order-1">
        <BBreadcrumb
          v-if="$route.meta.breadcrumb"
          :items="$route.meta.breadcrumb || []"
        />
      </div>
    </div>

    <MemoTable
      ref="memoTable"
      @view:row="memo => $refs.memoView.viewMemo(memo)"
    />

    <MemoView
      ref="memoView"
    />
  </BContainer>
</template>
<script>
import { mapGetters } from 'vuex'

import MemoTable from './components/MemoTable.vue'
import MemoView from './components/MemoView.vue'

import MxMisc from '@/mixins/misc'

export default {
  name: 'AccountantCustomerMemosBase',

  components: {
    MemoTable,
    MemoView
  },

  mixins: [
    MxMisc
  ],

  middleware: [
    'auth',
    'accountant'
  ],

  metaInfo: () => ({
    title: 'Customer Memos'
  }),

  computed: {
    ...mapGetters({
      currentUser: 'auth/user'
    })
  },

  methods: {
    getTabRoute (tabName) {
      return `/accountant/tracking/customer-memos/${tabName}`
    },

    getActiveRoute (tabName) {
      return this.$route.path === this.getTabRoute(tabName)
    }
  }
}
</script>
